import * as React from "react";

const IconUT = (props) => (
  <svg width={40} height={40} viewBox="0 0 40 40" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z"
      className="bg-circle"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.221 15.061a2.709 2.709 0 00-1.886-1.937C26.67 12.667 20 12.667 20 12.667s-6.671 0-8.335.457a2.708 2.708 0 00-1.886 1.937c-.445 1.708-.445 5.272-.445 5.272s0 3.564.445 5.273a2.709 2.709 0 001.886 1.936C13.33 28 20 28 20 28s6.671 0 8.335-.458a2.709 2.709 0 001.886-1.936c.446-1.709.446-5.273.446-5.273s0-3.564-.446-5.272"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 24v-6.667l5.333 3.334L18 24z"
      fill="#0F41B4"
    />
  </svg>
)

export default IconUT;